import Vue from "vue";
import Vuex from "vuex";
import mainStore from "./modules/main";

Vue.use(Vuex);

const store = new Vuex.Store(mainStore);

export default store;
